export default __webpack_public_path__ + "static/media/i_icon.575ce3d2.svg";